/**
 * @generated SignedSource<<6d5f3b07738ac9fc58a60f72b4733534>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CandidateProfileImageEditInput = {
  clientMutationId?: string | null | undefined;
  profileImage: string;
};
export type CandidateProfileImageEditMutation$variables = {
  input: CandidateProfileImageEditInput;
};
export type CandidateProfileImageEditMutation$data = {
  readonly CandidateProfileImageEdit: {
    readonly error: string | null | undefined;
    readonly me: {
      readonly id: string;
      readonly profileImage: {
        readonly url: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CandidateProfileImageEditMutation = {
  response: CandidateProfileImageEditMutation$data;
  variables: CandidateProfileImageEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "height",
      "value": 50
    },
    {
      "kind": "Literal",
      "name": "width",
      "value": 50
    }
  ],
  "kind": "ScalarField",
  "name": "url",
  "storageKey": "url(height:50,width:50)"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CandidateProfileImageEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CandidateProfileImageEditPayload",
        "kind": "LinkedField",
        "name": "CandidateProfileImageEdit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Candidate",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "profileImage",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CandidateProfileImageEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CandidateProfileImageEditPayload",
        "kind": "LinkedField",
        "name": "CandidateProfileImageEdit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Candidate",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "profileImage",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "38d179bf401d0df9898b273129dca170",
    "id": null,
    "metadata": {},
    "name": "CandidateProfileImageEditMutation",
    "operationKind": "mutation",
    "text": "mutation CandidateProfileImageEditMutation(\n  $input: CandidateProfileImageEditInput!\n) {\n  CandidateProfileImageEdit(input: $input) {\n    me {\n      id\n      profileImage {\n        url(height: 50, width: 50)\n        id\n      }\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "1c3fe5a9636f871a984d83959d874882";

export default node;
